export default __webpack_public_path__ + "static/media/logo_1.4fb16fa0.svg";